'use strict'

import Helper from '@/utils/helper'
import AdPlaylist from '@/app/service/api/model/ad/ad-playlist'
import AdTextItemTypes from '@/app/service/api/model/ad/adv-text-item-types'

const MAIN = 'MAIN'
const SIDE = 'SIDE'
const BOTTOM = 'BOTTOM'

class AdPlaylists {
  constructor ({ baseUrl, playlists }) {
    Helper.checkString('AdPlaylists.label', baseUrl)
    Helper.checkNotEmptyArray('AdPlaylists.playlists', playlists)

    this.baseUrl = baseUrl
    this.playlists = playlists ? playlists.map(item => new AdPlaylist(item)) : null
    this.activeIndex = 0

    this.playlistsMainItems = []
    this.playlistsSideItems = []
    this.playlistsBottomItems = []
    if (this.playlists) {
      const buffItems = this.playlists.reduce((p, n) => p.concat(Helper.getValue(n.getItems(), [])), [])
      const maxFrequency = Math.max(...buffItems.map(item => item.getDisplayFrequency()))
      for (let i = 0; i < maxFrequency; i++) {
        buffItems.forEach(item => {
          if (item.getDisplayFrequency() > i) {
            const regionCode = item.getRegionCode().toUpperCase()
            if (regionCode === MAIN) {
              this.playlistsMainItems.push(item)
            } else if (regionCode === SIDE) {
              this.playlistsSideItems.push(item)
            } else if (regionCode === BOTTOM) {
              this.playlistsBottomItems.push(item)
            }
          }
        })
      }
    }
    // Формируется единый плейлист из текстовых элементов всех плейлистов
    this.playlistsTextItems = []
    const tmpPlaylistsTextItems = playlists ? this.playlists.reduce((p, n) => p.concat(Helper.getValue(n.getTextItems(), [])), []) : null
    if (tmpPlaylistsTextItems) {
      const maxFrequency = Math.max(...tmpPlaylistsTextItems.map(item => item.getFrequency()))
      for (let i = 0; i < maxFrequency; i++) {
        tmpPlaylistsTextItems.forEach((item) => {
          if (AdTextItemTypes.isValidValue(item.getType()) && item.getFrequency() > i) {
            this.playlistsTextItems.push(item)
          }
        })
      }
    }
    // Формируется плейлист аудио элементов
    this.playlistsAudioItems = playlists
      ? this.playlists.reduce((prev, curr) => prev.concat(Helper.getValue(curr.getAudioItems(), [])), [])
      : []
  }

  getBaseUrl () {
    return this.baseUrl
  }

  getPlaylists () {
    return this.playlists
  }

  getPlaylistsMainItems () {
    return this.playlistsMainItems
  }

  getPlaylistsSideItems () {
    return this.playlistsSideItems
  }

  getPlaylistsBottomItems () {
    return this.playlistsBottomItems
  }

  getPlaylistsTextItems () {
    return this.playlistsTextItems
  }

  isEmptyTextPlaylist () {
    return this.playlistsTextItems.length === 0
  }

  /**
   * Проверка на 1 уникальный элемент
   */
  isPlaylistsOneItem () {
    return [...new Set(this.playlistsTextItems.map(item => item.getId()))].length === 1
  }

  isLastItem () {
    return this.activeIndex === this.playlistsTextItems.length - 1
  }

  setNextIndex () {
    if (this.playlistsTextItems.length - 1 <= this.activeIndex) {
      this.activeIndex = 0
    } else {
      this.activeIndex += 1
    }
  }

  getActiveItem () {
    return this.playlistsTextItems[this.activeIndex]
  }

  getPlaylistsAudioItems () {
    return this.playlistsAudioItems
  }

  getActiveIndex () {
    return this.activeIndex
  }

  toString () {
    return 'AdPlaylists{' +
      'baseUrl=' + '\'' + this.baseUrl + '\'' +
      ', playlists=' + '\'' + this.playlists + '\'' +
      ', activeIndex=' + '\'' + this.activeIndex + '\'' +
      ', playlistsMainItems=' + '\'' + this.playlistsMainItems + '\'' +
      ', playlistsSideItems=' + '\'' + this.playlistsSideItems + '\'' +
      ', playlistsBottomItems=' + '\'' + this.playlistsBottomItems + '\'' +
      ', playlistsTextItems=' + '\'' + this.playlistsTextItems + '\'' +
      ', playlistsAudioItems=' + '\'' + this.playlistsAudioItems + '\'' +
      '}'
  }
}

export default AdPlaylists
